import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { selectUGCListByUsers } from './UGCBaseSelector';
import { selectContentNoticeEntities } from '../EntitiesSelector';

const getTransactions = state => state.getIn(['ugc', 'contentAdvisoriesTransactions'], Immutable.Map());
const getContentNoticeIds = state => state.getIn(['ugc', 'contentAdvisories', 'results'], Immutable.List());

// All Content Notices
export const selectContentNotices = createSelector(
  [getContentNoticeIds, selectContentNoticeEntities],
  (contentNoticeIds, contentNoticeEntities) =>
    contentNoticeIds.map(contentNoticeId => contentNoticeEntities.get(contentNoticeId.toString()))
);

const pagination = state => state.getIn(['ugc', 'contentAdvisories', 'pagination'], Immutable.Map());

export const selectContentNoticesPagination = createSelector([pagination], page => page);

export const selectContentAdvisoriesByUsers = selectUGCListByUsers('contentAdvisories');
export const selectContentAdvisoriesTransactions = createSelector([getTransactions], transactions => transactions);

export default {
  selectContentAdvisoriesByUsers,
  selectContentAdvisoriesTransactions,
  selectContentNotices,
  selectContentNoticesPagination
};
